import React from 'react';
import { FormattedMessage } from 'react-intl';

import messages from '../messages';

// noinspection JSValidateTypes
const ConfirmationOptionLabel = () => <FormattedMessage {...messages.confirmation} />;

export default ConfirmationOptionLabel;
